import React, { useRef, useState, useEffect } from "react";
import { Navbar } from "../components/Navbar";
import { Hero } from "../components/Hero";
import { HowItWorks } from "../components/HowItWorks";
import { InterestCalculator } from "../components/InterestCalculator";
import { DemoWorkspace } from "../components/DemoWorkspace";
import { Pricing } from "../components/Pricing";
import { Waitlist } from "../components/Waitlist";
import { Footer } from "../components/Footer";
import { getWaitlistCount } from "../lib/api";
import { usePageMeta } from "../lib/seo";

export default function Landing() {
  usePageMeta({
    title: "KashBaaki — Recover Delayed MSME Payments with Statutory Interest | MSMED Act 2006",
    description:
      "KashBaaki helps Indian Micro & Small Enterprises track overdue B2B invoices, auto-calculate statutory interest under Section 16 of the MSMED Act, 2006, generate demand notices, and escalate through MSEFC / Samadhaan.",
    path: "/",
  });
  const waitlistRef = useRef(null);
  const [stats, setStats] = useState(null);

  const loadStats = () => {
    getWaitlistCount().then(setStats).catch(() => {});
  };
  useEffect(loadStats, []);

  const scrollToWaitlist = (plan) => {
    if (plan && waitlistRef.current) waitlistRef.current.setPlan(plan);
    document.getElementById("waitlist")?.scrollIntoView({ behavior: "smooth" });
  };

  return (
    <div className="App bg-paper">
      <Navbar onCta={() => scrollToWaitlist()} />
      <Hero onCta={() => scrollToWaitlist()} stats={stats} />
      <HowItWorks />
      <InterestCalculator />
      <DemoWorkspace />
      <Pricing onSelect={(p) => scrollToWaitlist(p)} />
      <Waitlist ref={waitlistRef} onJoined={loadStats} />
      <Footer />
    </div>
  );
}
